export default __webpack_public_path__ + "static/media/lollies.25734a2c.webp";